import { useEffect, useRef } from 'react'

/**
 * Calls `callback` every `intervalMs` while `enabled` is true.
 * Cleans up on unmount or when `enabled` becomes false.
 */
export function usePolling(
  callback: () => void,
  intervalMs: number,
  enabled: boolean,
) {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (!enabled || intervalMs <= 0) return

    const id = setInterval(() => savedCallback.current(), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs, enabled])
}
